export default __webpack_public_path__ + "static/POLITIQUE-CONFIDENTIALITE-20241009-72f44ec59ed6ebc55a38b527f04ecf96.pdf";